import { useState, useEffect } from 'react';
import defaultTheme from '@theme/defaultTheme';
import kidsTheme from '@theme/kidsTheme';
import hipsterTheme from '@theme/hipsterTheme';
import professionalTheme from '@theme/professionalTheme';

const useTheme = () => {
  const [theme, setTheme] = useState(defaultTheme);
  const [loaded, setLoaded] = useState(false);
  const [themeName, setThemeName] = useState('default');

  useEffect(() => {
    let tempTheme = defaultTheme;
    switch (themeName) {
      case 'default':
        tempTheme = defaultTheme;
        break;
      case 'kids':
        tempTheme = kidsTheme;
        break;
      case 'hipster':
        tempTheme = hipsterTheme;
        break;
      case 'professional':
        tempTheme = professionalTheme;
        break;
      default:
        tempTheme = defaultTheme;
        break;
    }
    setTheme({...tempTheme});
    setLoaded(true);
  }, [themeName]);

  return { theme, themeName, setThemeName, loaded };
};
export default useTheme;
